
import React from "react";
import { cn } from "@/lib/utils";

/**
 * Green pulsing dot for denoting the active task.
 * Absolutely positioned at the bottom-right corner of a relatively positioned card.
 * The pulse animation is slow, with extra interval between pulses.
 */
export const TaskActiveDot: React.FC<{ className?: string }> = ({ className }) => (
  <div className={cn("absolute bottom-2 right-2 z-10 flex items-end justify-end", className)}>
    <span className="relative flex h-4 w-4">
      {/* Outer pulse effect, custom animation for slower pulse and gap */}
      <span className="absolute inline-flex h-full w-full rounded-full bg-green-500 opacity-60 animate-slow-pulse-with-gap"></span>
      {/* Green dot */}
      <span className="relative inline-flex rounded-full h-4 w-4 bg-green-500 border-2 border-white dark:border-gray-800 shadow"></span>
    </span>
  </div>
);
